export const ADDRESS_TYPE = {
  NONE: -1,
  MEET_AUTO_GENERATE: 0,
  EXISTING_LINK: 1,
  PERSONAL_ADDRESS: 2,
  CUSTOMER_ADDRESS: 3,
  ZOOM_AUTO_GENERATE: 4,
  PHONE_NUMBER: 5,
  WHATSAPP: 6,
  EXLY_CONNECT: 7,
  ZOOM_WEBINAR: 8,
  ISV_WEBINAR: 10,
};

export const LISTING_TYPES = {
  APPOINTMENTS: 0,
  ONE_ON_ONE_CLASSES: 1,
  GROUP_CLASSES: 2,
  WORKSHOPS: 3,
  NO_SCHEDULE: 4,
  RECORDED_CONTENT: 5,
  MERCHANDISE: 6,
  ROLLING_CLASSES: 7,
  TELEGRAM: 8,
  WEBINAR: 9,
  WHATSAPP: 10,
  BRANDED_COMMUNITY: 11,
  PLANS: 9999, // Since plans are pseudo-listings and need to be treated like listings on host page
};

export const MERCHANDISE_SHIPPING_STATUS = {
  PENDING: 1,
  NOT_AVAILABLE: 2,
  DISPATCHED: 3,
  DELIVERED: 4,
};

export const LISTING_MODES = {
  ONLINE: "Online",
  OFFLINE: "Offline",
};

/**
 * denotes different types of offering/listing skus
 */
export const LISTING_STATUSES = {
  DRAFT: 0,
  LIVE: 1,
  SOLD_OUT: 2,
  EXPIRED: 3,
};

export const LISTING_TYPE_NAMES = {
  [LISTING_TYPES.APPOINTMENTS]: "One-on-One appointment",
  [LISTING_TYPES.ONE_ON_ONE_CLASSES]: "One-on-One Class",
  [LISTING_TYPES.GROUP_CLASSES]: "Group Class",
  [LISTING_TYPES.WORKSHOPS]: "Workshop",
  [LISTING_TYPES.NO_SCHEDULE]: "Quick Payment Page",
  [LISTING_TYPES.RECORDED_CONTENT]: "Content: Videos/ Files",
  [LISTING_TYPES.MERCHANDISE]: "Merchandise",
  [LISTING_TYPES.ROLLING_CLASSES]: "Flexible Class",
  [LISTING_TYPES.TELEGRAM]: "Telegram Community",
  [LISTING_TYPES.WEBINAR]: "Live Webinars",
  [LISTING_TYPES.WHATSAPP]: "Whatsapp Community",
  [LISTING_TYPES.BRANDED_COMMUNITY]: "Branded Community",
};

export const LISTING_AVAILABILITY_CHOICES = {
  EVERYDAY: 0,
  SINGLE_DAY: 1,
  EVERY_WEEKDAY: 2,
  CUSTOM: 3,
  NOT_SURE: 4,
  SELECTED_DATES: 5,
  SELECTED_DAYS: 6,
};
